import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
import Dialog from './Dialog';
const SplitDialog = (props) => {
    const { leftContent, rightContent, leftContentClassName = '', rightContentClassName = '', className = '', useOverflow = true } = props, remainingProps = __rest(props, ["leftContent", "rightContent", "leftContentClassName", "rightContentClassName", "className", "useOverflow"]);
    const dialogClassName = `split-dialog ${className}`;
    const dividerClasses = classNames('split-divider', 'bg-lighter');
    const body = (_jsxs("div", Object.assign({ className: 'split-wrapper' }, { children: [_jsxs("div", Object.assign({ className: `split-left ${leftContentClassName}` }, { children: [leftContent, _jsx("div", { className: dividerClasses })] })), _jsx("div", Object.assign({ className: `split-right ${rightContentClassName}` }, { children: rightContent }))] })));
    return _jsx(Dialog, Object.assign({}, remainingProps, { body: body, className: dialogClassName, useOverflow: useOverflow }));
};
export default SplitDialog;
